import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, CDN_URL, formatDate, formatMoney, generateRandomString, getInlineLoader, WEB_SOCKET_URL } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSE_REQUEST,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_COULD_NOT_FETCH_DATA,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NO_MESSAGES,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECENT_REQUESTS,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SEND_MESSAGE_TO_AGENT,
	STR_SERVICE_PROVIDER,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_AGENT_PROFILE,
	STR_YOUR_REQUEST
} from "../Strings";
import { BsCheck, BsCheckAll, BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdArrowBack, MdCheckCircle, MdClose, MdContactPage, MdImage, MdInfoOutline, MdMenu, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSend, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgMenuRight, CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp, FaUserTag } from "react-icons/fa6";
import { IoIosSend } from "react-icons/io";
import { RiAttachment2, RiAttachmentLine } from "react-icons/ri";

export default function View({ partnerId }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [partnerData, setPartnerData] = useState(null);
	const [inboxMessages, setInboxMessages] = useState(null);
	const [message, setMessage] = useState("");
	const [isSendingMessage, setIsSendingMessage] = useState(false);
	const [selectAttachment, setSelectAttachment] = useState(false);
	const [attachment, setAttachment] = useState(null);

	const webSocketRef = useRef(null)
	const [ webSocketConnected, setWebSocketConnected ] = useState(2); //0 = not, 1=conn, 2= start
	const [ webSocketReconnectTimer, setWebSocketReconnectTimer ] = useState(null);
	const wsRandomId = generateRandomString();

	async function init() {
		//run initializations here
		setReady(false);
		//..
		await Promise.all([
			getPartnerData(),
			getInboxMessages(),
		]);

		if(appContext.currentUserData) {
      setupWebSocket();
    }

		setReady(true);
	}

	function setupWebSocket() {
		//subscribe for data from websocket server
		webSocketRef.current = new WebSocket(WEB_SOCKET_URL);
		webSocketRef.current.addEventListener('open', async () => {
			//send subscription message
			// using delay hack
			
			setTimeout(async () => {
				if(webSocketRef.current.readyState === WebSocket.OPEN) {

					//subscribe for game all inboxes
					webSocketRef.current.send(JSON.stringify({
						subscribeFor: 'inbox-messages',
						userId: appContext?.currentUserData?.id || "",
						partnerId,
						userToken: appContext?.currentUserData?.token || "",
						sourceId: 'inbox'+wsRandomId,
					}));

					
				}
			}, 3000);
			setWebSocketConnected(1);
				
			
		})

		webSocketRef.current.addEventListener('close', (e) => {
			if(!e.wasClean) {
				setWebSocketConnected(0);
				//try to reconnect after 5 seconds
				setWebSocketReconnectTimer((prevTimer) => {
					if(prevTimer) {
						clearInterval(prevTimer);
					}

					let timer = setInterval(() => {
						setupWebSocket();
					}, 5000);

					return timer;
				})
			}
		})

		webSocketRef.current.addEventListener('message', (e) => {
			const response = JSON.parse(e.data);
			console.log("Websocket response", response);

			if(response.subscribeFor === 'inbox-messages') {
				setInboxMessages(response.data);
			}
			
		})
	}

	function closeWebSocket() {
		//send unsubscribe req 
		if(webSocketRef.current && webSocketRef.current.readyState === WebSocket.OPEN) {
			webSocketRef.current.send(JSON.stringify({
				unsubscribeFor: 'inbox-messages',
				userId: appContext?.currentUserData?.id || "",
				partnerId,
				userToken: appContext?.currentUserData?.token || "",
				sourceId: 'inbox'+wsRandomId,
			}));

			
		}

		//then close connection
		if(webSocketRef.current) {
			webSocketRef.current.close();
		}

		//clear  reconnect timer
		if(webSocketReconnectTimer) {
			clearInterval(webSocketReconnectTimer);
		}
	}

	function handleAttachmentChange(e) {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setAttachment(imageUrl);
    } else {
			setAttachment(null);
		}
  }

	async function markMessageAsRead(_message) {
		if(_message.isRead === 'no') {
			if(Number(_message.fromId) === Number(partnerId)) {
				//mark as read
				await callApi("mark-message-as-read", { id: _message.id }).then((response) => {
					if(response.status === 1) {
						//good
					}
				})
			}
		}
	}

	function getViewerTopView() {
		if(partnerData) {
			return (
				<div
					className="container d-flex bg-surface"
					style={{
						height: "100%",
					}}
				>
					<MdArrowBack
						className="align-self-center"
						size={30}
						style={{
							flexShrink: "0",
							cursor: "pointer",
						}}
						onClick={appContext.navBack}
					/>

					<MdPerson 
						size={24}
						style={{
							flexShrink: "0",
							marginLeft: "10px",
							marginRight: "3px"
						}}
						className="align-self-center text-secondary"
					/>
					<h6
						className="align-self-center font-semi-bold text-secondary"
						style={{
							flexShrink: 1,    // allow shrinking
							flexGrow: 1,      // allow growing to fill remaining space
							minWidth: 0,      // allow shrinking below content size
							overflow: "hidden",
							whiteSpace: "nowrap",
							textOverflow: "ellipsis",
							margin: 0,         // reset default h6 margins to avoid overflow
							fontSize: "18px"
						}}
					>
						{partnerData.agentName || partnerData.phone}
					</h6>

					<CgMenuRight
						size={32}
						style={{
							flexShrink: "0",
							marginLeft: "20px",
							marginRight: "0px"
						}}
						className="align-self-center"
						onClick={() => {
							appContext.navTo({
								item: 'side-view',
								subItem: 'agent_profile',
								extraItem: partnerId,
							})
						}}
					/>
				</div>
			)
		}

		return null;
	}

	async function sendMessage() {
		const _attachment = document.getElementById('_attachmentPicker').files[0];
		if(message.trim().length > 0 || _attachment) {
			setIsSendingMessage(true);
			await callApi(
				"send-message",
				{
					fromId: appContext.currentUserData.id,
					toId: partnerId,
					body: message,
					attachment: _attachment || '',
				}
			).then((response) => {
				if(response.status === 1) {
					setMessage("");
					getInboxMessages();

					//clean attachment
					setSelectAttachment(false);
					document.getElementById('_attachmentPicker').value = '';
					setAttachment(null);

				} else {
					appContext.tellError(response.msg);
				}
			})
			setIsSendingMessage(false);
		} 
	}

	async function getPartnerData() {
		await callApi('get-agent-data', { id: partnerId }).then((response) => {
			if(response.status === 1) {
				setPartnerData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	async function getInboxMessages() {
		await callApi('get-inbox-messages', { partnerId}).then((response) => {
			if(response.status === 1) {
				setInboxMessages(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	useEffect(() => {
		init();

		return () => {
			appContext.setViewerTopView(null);
			closeWebSocket();
		}

		
	}, [ partnerId ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		
		if (ready && partnerData && appContext.isAgentProfileComplete) {
			appContext.setViewerTopView(getViewerTopView());
		}

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ partnerData, ready, appContext.isAgentProfileComplete  ])

	useEffect(() => {
		try {
			document.getElementById('_messagesBottomLine').scrollIntoView({ behavior: "smooth" })
		} catch (error) {
			//..
		}
	}, [ inboxMessages ])


	if (ready && partnerData && inboxMessages) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					className="mNoScrollBar mInbox"
				>
					<div className="mBody">
						{
							(inboxMessages && inboxMessages.length > 0) ?
							inboxMessages.map((item, i) => {
								markMessageAsRead(item);
								
								return (
									<div 
										className="mMessageContainer" 
										key={i}
										data-is-from-user={Number(item.fromId) === Number(appContext.currentUserData.id)}
									>
										<div className="mMessage">

											{
												(item.attachment) ?
												<img
													style={{
														display: "block",
														width: "100%",
														height: "auto",
													}}
													src={CDN_URL+item.attachment}
												/>
												:""
											}

											{
												(item.body) ?
												<pre>
													{item.body}
												</pre>
												:""
											}

											{
												(Number(item.toId) === Number(partnerId)) ?

												<div className="text-end mt-2">
													{
														(item.isRead === 'yes') ?
														<BsCheckAll size={18}/>
														:
														<BsCheck size={18}/>
													}
												</div>
												:""
											}
											
											<div className="text-end mt-2">
												<span className="font-light" style={{ fontSize: "10px" }}>{formatDate(item.dateCreated)}</span>
											</div>
										</div>
									</div>
								)
							})
							:
							<h6
								style={{
									fontSize: "14px",
									padding: "10px"
								}}
							>
								{STR_NO_MESSAGES[appContext.language]}
							</h6>
						}
						<div
							id="_messagesBottomLine"
							style={{
								width: "100%",
								height: "20px"
							}}
						>
							
						</div>
					</div>

					<div className="mTypingBox bg-surface">
						<input
							hidden={true}
							id="_attachmentPicker"
							type="file"
							accept="image/*"
							onChange={handleAttachmentChange}
						/>

						{
							(selectAttachment) ?
							<div
								style={{
									flexShrink: 1,
									flexGrow: 1,
									height: "100%",
								}}
								className="align-self-center"
								onClick={() => {
									document.getElementById('_attachmentPicker').click();
								}}
							>
								
								{
									(attachment) ?
									<img
										style={{
											height: "100%",
											width: "auto",
										}}
										src={attachment}
									/>
									:
									<MdImage
										style={{
											height: "100%",
											width: "100%"
										}}
										className="text-muted"
									/>
								}
							</div>
							:
							<textarea
								style={{
									flexShrink: 1,
									flexGrow: 1,
									height: "100%",
									fontSize: "14px"
								}}
								className="form-control align-self-center"
								value={message}
								onChange={(e) => setMessage(e.target.value)}
							/>
						}

						{
							(isSendingMessage) ?
							<div className="mSupportLoading">
								{getInlineLoader()}
							</div>
							:
							<>
								
								{
									(selectAttachment) ?
									<MdClose
										style={{
											flexShrink: 1,
											margin: "3px"
										}}
										size={32}
										className="align-self-center text-secondary"
										onClick={() => {
											setSelectAttachment(false);
											document.getElementById('_attachmentPicker').value = '';
											setAttachment(null);
										}}
									/>
									:
									<RiAttachment2
										style={{
											flexShrink: 1,
											margin: "3px"
										}}
										size={32}
										className="align-self-center text-secondary"
										onClick={() => setSelectAttachment(true)}
									/>
								}

								<IoIosSend
									style={{
										flexShrink: 1,
										margin: "3px"
									}}
									size={40}
									className="align-self-center text-secondary"
									onClick={sendMessage}
								/>
							</>
							
						}
						
					</div>
				</div>
			)
			//..
		} else {
			return <EditAgentProfile/>
		}
	
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}